import { CSSProperties } from 'react';

// Courier New (monospace) ensures VGS iframe text (card number, CVV) matches static masked
// fields pixel-for-pixel. Inter can't be used in VGS fields — cross-origin iframes can't load
// parent-page fonts.
export const CARD_VALUE_STYLE: CSSProperties = {
  color: 'white',
  fontSize: 'var(--font-size-16)',
  fontWeight: 'var(--font-weight-400)',
  fontFamily: '"Courier New", Courier, monospace',
  lineHeight: '24px',
  height: 24,
};

export const MASKED_CVV = '•••';

export const CARD_HOLDER_MAX_WIDTH = 120;
